export default __webpack_public_path__ + "static/media/switchClosed.19b19532.svg";